<template>
  <div id="tools-base">
    <b-tabs v-model="activeTabIndex" class="app-vertical-tabs" justified
            nav-class="app-vertical-tabs-nav" pills vertical
    >
      <b-tab v-for="tool of tools" :key="tool.slug">
        <template #title>
          <div>{{ tool.title }}</div>
          <div v-if="tool.subtitle" class="tool-nav-subtitle">{{ tool.subtitle }}</div>
        </template>
        <component :is="tool.component" />
      </b-tab>
    </b-tabs>
  </div>
</template>

<style lang="scss">
#tools-base {
  .app-vertical-tabs {
    margin-top: 0;
  }

  .app-vertical-tabs-nav {
    max-height: 500px;
    overflow-y: auto;
    min-width: 220px;
  }

  .tool-nav-subtitle {
    font-size: 0.72rem;
    font-weight: 400;
    opacity: 0.65;
    margin-top: 2px;
    line-height: 1.3;

    @media (max-width: 991px) {
      display: none;
    }
  }

  @media (max-width: 991px) {
    .app-vertical-tabs {
      flex-direction: column !important;
    }

    .app-vertical-tabs > .col-auto {
      flex: 0 0 100% !important;
      max-width: 100% !important;
      width: 100% !important;
      padding: 0 !important;
    }

    .app-vertical-tabs-nav {
      min-width: 100% !important;
      max-width: 100% !important;
      width: 100% !important;
      margin-right: 0;
      margin-bottom: 1rem;
      display: flex !important;
      flex-direction: row !important;
      flex-wrap: nowrap !important;
      overflow-x: auto;
      position: static;
      padding: 0;
      border-radius: 8px;
      -webkit-overflow-scrolling: touch;

      .nav-item {
        flex-shrink: 0;

        .nav-link {
          border-left: none;
          border-bottom: 3px solid transparent;
          padding: 8px 16px;
          white-space: nowrap;
          font-size: 0.78rem;

          &.active {
            border-bottom-color: $color_primary;
            border-left-color: transparent;
          }
        }
      }
    }

    > .app-vertical-tabs > .tab-content {
      padding: 0;
    }
  }

  > .app-vertical-tabs > .tab-content {
    padding: 0.25rem 0.5rem 0 1.25rem;
  }

  .tool-result {
    background: #f8f9fa;
    border: 1px solid $color_border;
    border-radius: 8px;
    padding: 12px 16px;
    font-size: 0.95rem;
    line-height: 1.6;

    &--success {
      background: rgba(#28a745, 0.06);
      border-color: rgba(#28a745, 0.2);
    }

    &--warning {
      background: rgba(#ffc107, 0.08);
      border-color: rgba(#ffc107, 0.25);
    }

    &--danger {
      background: rgba(#dc3545, 0.06);
      border-color: rgba(#dc3545, 0.2);
    }
  }
}
</style>
<script>
import KidsBmi from './kids-bmi'
import {SELECTED_TOOL} from "@utils/storageKeys";
import AdultBmi from './adult-bmi'
import insulineResistance from './insuline-resistance'
import dailyFiber from './daily-fiber'
import gfrQuation from "./gfr-equation";
import hamwi from "@components/tools/hamwi.vue";

export default {
  components: { KidsBmi, AdultBmi, insulineResistance, dailyFiber, gfrQuation, hamwi },
  data() {
    return {
      activeTabIndex: 0,
      tools: [
        { title: this.$t('tools.cole.title'), subtitle: this.$t('tools.cole.subtitle'), slug: 'kids-bmi', component: KidsBmi },
        { title: this.$t('tools.bmi.menu'), subtitle: this.$t('tools.bmi.subtitle'), slug: 'bmi-adult', component: AdultBmi },
        { title: this.$t('tools.insulin.menu'), slug: 'insuline-resistance', component: insulineResistance },
        { title: this.$t('tools.fiber.menu'), slug: 'daily-fiber', component: dailyFiber },
        { title: this.$t('tools.gfr.menu'), subtitle: this.$t('tools.gfr.subtitle'), slug: 'gfr-equation', component: gfrQuation },
        { title: this.$t('tools.hamwi.menu'), subtitle: this.$t('tools.hamwi.subtitle'), slug: 'hamwi', component: hamwi },
      ],
    }
  },
  watch: {
    activeTabIndex(idx) {
      if (this.tools[idx]) {
        localStorage.setItem(SELECTED_TOOL, this.tools[idx].slug);
      }
    },
  },
  created() {
    const saved = localStorage.getItem(SELECTED_TOOL);
    if (saved) {
      const idx = this.tools.findIndex(t => t.slug === saved);
      if (idx >= 0) this.activeTabIndex = idx;
    }
  },
}
</script>
